var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noticedialog"},[_c('div',{staticClass:"notice-content"},[_c('div',{staticClass:"notice"},[_c('div',{staticClass:"noticetext"},[_c('div',[_vm._v(_vm._s(_vm.noticeMessage))]),_vm._v(" "),_c('div',{staticClass:"sure",on:{"click":_vm.sureClose}},[_vm._v("确 定")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-686460e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/notice.vue
// module id = null
// module chunks = 